import { render, staticRenderFns } from "./fundRecord.vue?vue&type=template&id=5de0ff41&scoped=true"
import script from "./fundRecord.vue?vue&type=script&lang=js"
export * from "./fundRecord.vue?vue&type=script&lang=js"
import style0 from "./fundRecord.vue?vue&type=style&index=0&id=5de0ff41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0ff41",
  null
  
)

export default component.exports